import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FilterSettings, FilterType} from '../../../common/dialog/generic-filter-dialog';
import {BuildUsuarioAgroChips, GetAgroFilterFromColumns, TableColumnData, UsuarioAgro} from '../usuarios.component';
import {CuentasService, DialogsService, SpinnerService} from '../../../../services';
import {GenericTableDataSource} from '../../../common/dialog/generic-table-dialog';
import { ParseEstadoAgro } from '../usuario-agro-detail';
import {ChipFilterItem} from '../../../common';
import {Observable} from 'rxjs';
import {Subscription} from 'rxjs/Subscription';
import {PATH_DETALLE_USUARIO_AGRO, PATH_EDITAR_USUARIO_AGRO} from '../../../../navigation/navigation.module';
import {Router} from '@angular/router';
import {MdDialog, MdDialogConfig, MdDialogRef, MdSnackBar} from '@angular/material';
import {AcoCuitDialogComponent} from '../aco-cuit-dialog';
import {CuitPipe} from '../../../../utils';

@Component({
  selector: 'app-usuario-agro-historial',
  templateUrl: './usuario-agro-historial.component.html',
  styleUrls: ['./usuario-agro-historial.component.scss'],
  providers: [CuitPipe]
})
export class UsuarioAgroHistorialComponent implements OnInit, OnDestroy {
  @ViewChild('cardTable', { read: ElementRef }) table: ElementRef;
  @ViewChild('topScroller') topScroller: ElementRef;
  @ViewChild('tableHead') tableHeader: ElementRef;

  agroTableWidth = '500px';

  orderTimeout = null;
  agroResponseData: UsuarioAgro[] = [];

  historialChips: ChipFilterItem[] = [];

  @Output() onChipsListChanged = new EventEmitter<{}>();

  // paginador
  paginadorMarginLeft = '0px'
  pageSize = 10;
  currentPage = 0;
  resultsFullCount = 0;
  resultsPageCount = 0;

  cargando = false;

  sub: Subscription;

  agroRoles = [];

  estados = [
    {raw: 'INACTIVE', estado: 'Inactivo', id: 0},
    {raw: 'ACTIVE', estado: 'Activo', id: 1},
    {raw: 'UNKNOWN', estado: 'Desconocido', id: 3},
  ];

  // el orden en este objeto delimita el orden de columnas
  columnsDataSource: TableColumnData[] = [
    { column: 'accion', title: '', width: '50px', order: null, filter: null, filterType: '', filterPropertyName: '', sortable: false },
    { column: 'usuario', title: 'Usuario', width: '150px', order: null, filter: null, filterType: FilterType.string, filterPropertyName: 'Usuario', sortable: true },
    { column: 'email', title: 'Email', width: '250px', order: null, filter: null, filterType: FilterType.string, filterPropertyName: 'Mail', sortable: true },
    { column: 'nombre', title: 'Nombre', width: '150px', order: null, filter: null, filterType: FilterType.string, filterPropertyName: 'Nombre', sortable: true },
    { column: 'apellido', title: 'Apellido', width: '150px', order: null, filter: null, filterType: FilterType.string, filterPropertyName: 'Apellido', sortable: true },
    { column: 'estados', title: 'Estado', width: '175px', order: null, filter: null, filterType: FilterType.chip, filterPropertyName: 'EstadosId', sortable: true },
    { column: 'roles', title: 'Permisos', width: '200px', order: null, filter: null, filterType: FilterType.chip, filterPropertyName: 'RolesId', sortable: true },
    { column: 'cuitRazon', title: 'Empresa', width: '275px', order: null, filter: null, filterType: FilterType.cuitRazon, filterPropertyName: '', sortable: true },
    { column: 'acopios', title: 'Acopios', width: '200px', order: null, filter: null, filterType: FilterType.rol, filterPropertyName: 'Acopios', sortable: true },
    { column: 'fechaCreac', title: 'Fecha de Creación', width: '170px', order: null, filter: null, filterType: FilterType.dateRange, filterPropertyName: 'MiembroDesde', sortable: true },
    { column: 'fechaVal', title: 'Fecha de Validación', width: '170px', order: false, filter: null, filterType: FilterType.dateRange, filterPropertyName: 'FechaValidacion', sortable: true },
    { column: 'usuarioVal', title: 'Usuario Validador', width: '150px', order: null, filter: null, filterType: FilterType.colaborador, filterPropertyName: 'UsuarioValidador', sortable: true },
  ];

  reloadList = false;

  constructor(
    private dialogsService: DialogsService,
    private cuentasService: CuentasService,
    private spinnerService: SpinnerService,
    private router: Router,
    private dialog: MdDialog,
    private cuitPipe: CuitPipe,
    private snackBar: MdSnackBar,
  ) {
    this.agroTableWidth = this.columnsDataSource.map(x => parseInt(x.width.slice(0, -2), 10)).reduce((a, b) => a + b).toString() + 'px';
    this.sub = spinnerService.showSoftFlag$.subscribe(x => {
      this.cargando = x;
    });
    cuentasService.agroSetupRoles();
    cuentasService.usuariosRoles$.subscribe(x => {
      this.agroRoles = x.map(y => ({ID: y.Id, ItemLabel: y.Nombre}));
    })
  }

  ngOnInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  loadData(): void {
    let payload = {
      PageSize: this.pageSize,
      PageNumber: this.currentPage,
      ColumnOrder: this.columnsDataSource.find(x => x.order !== null).column,
      AscendingOrder: this.columnsDataSource.find(x => x.order !== null).order,
      // corresponde a los estados 0=Inactivo, 1=Activo, 3=Desconocido. Se usa por defecto.
      EstadosId: [0, 1, 3]
    }
    payload = {...payload, ...GetAgroFilterFromColumns(this.columnsDataSource)}
    this.spinnerService.setSoftSpinnerShowFlag(true);
    this.cuentasService.agroGetHistory(payload).subscribe(x => {
      this.agroResponseData = x as UsuarioAgro[];
      this.agroResponseData.forEach(y => y.Roles.forEach(z => {
        z.Nombre = z.Nombre.replace('solo lectura', 'Usuario AGD Agro')
        z.Nombre = z.Nombre.replace('Agri Pago', 'AgriPago');
      }))
      this.resultsFullCount = this.agroResponseData.length ? this.agroResponseData[0].Total : 0;
      this.resultsPageCount = this.agroResponseData.length ? Math.ceil(this.agroResponseData[0].Total / this.pageSize) : 0;

      this.spinnerService.setSoftSpinnerShowFlag(false);
    }, err => this.spinnerService.setSoftSpinnerShowFlag(false))
  }

  onScroll(e, item) {
    if (item === 'main') {
      this.table.nativeElement.scrollLeft = e.target.scrollLeft;
    } else if (item === 'table') {
      this.topScroller.nativeElement.scrollLeft = e.target.scrollLeft;
    }
    this.paginadorMarginLeft = e.target.scrollLeft + 'px';
  }

  openFilter(col: TableColumnData) {
    clearTimeout(this.orderTimeout);
    const settings: FilterSettings = {
      FilterTitle: col.title,
      FilterName: col.column,
      FilterPlaceholder: col.title,
      FilterType: col.filterType,
    };
    if (col.column === 'estados') {
      settings.PreviousChipList = this.estados.map(x => ({ID: x.id, ItemLabel: x.estado}));
    } else if (col.column === 'roles') {
      settings.PreviousChipList = this.agroRoles;
    }
    // si existe el filtro, lo cargamos
    if (col.filter !== null) {
      switch (col.filterType) {
        case FilterType.string:
        case FilterType.singleSelect:
          settings.PreviousString = col.filter['MinValue'];
          break;
        case FilterType.colaborador:
        case FilterType.acopio:
          settings.PreviousChipList = col.filter['MinValue'];
          break;
        case FilterType.dateRange:
          settings.PreviousNumberMin = col.filter['MinValue'];
          settings.PreviousNumberMax = col.filter['MaxValue'];
          break;
        case FilterType.chip:
          settings.PreviousArrayNum = col.filter['MinValue'];
          break;
        case FilterType.cuitRazon:
          settings.PreviousString = col.filter['MinValue'];
          settings.PreviousNumberMin = col.filter['MaxValue'];
          break;
        case FilterType.rol:
          settings.PreviousArrayNum = col.filter['MinValue'];
      }
    }
    const sub = this.dialogsService.showGenericFilterDialog(settings).subscribe(res => {
      if (res) {
        col.filter = res.MinValue === null && res.MaxValue === null ? null : {MinValue: res.MinValue, MaxValue: res.MaxValue };
        this.buildChips();
        this.loadData();
      }
      sub.unsubscribe();
    });
  }

  buildChips(): void {
    this.historialChips = BuildUsuarioAgroChips(this.columnsDataSource);
    this.onChipsListChanged.emit({});
  }

  changeOrder(col: TableColumnData) {
    clearTimeout(this.orderTimeout);
    this.orderTimeout = setTimeout(() => {
      if (col.order === null) {
        this.columnsDataSource.forEach(x => x.order = null);
        col.order = true;
      } else {
        col.order = !col.order;
      }
      this.orderTimeout = null;
      this.loadData();
    }, 250);
  }

  showCuitDetail(row) {
    const data = row.Cuits ? row.Cuits.map(x => this.cuitPipe.transform(x.Cuit, '') + ' / ' + x.RazonSocial) : []
    let dialogRef: MdDialogRef<AcoCuitDialogComponent>;
    const config = new MdDialogConfig();
    config.width = '500px';
    dialogRef = this.dialog.open(AcoCuitDialogComponent, config);
    dialogRef.componentInstance.title = 'Cuit/Razón Social';
    dialogRef.componentInstance.data = data;
  }

  acopiosInfo(user) {
    const data = user.Acopios ? user.Acopios.map(x => x.RolName) : [];
    let dialogRef: MdDialogRef<AcoCuitDialogComponent>;
    const config = new MdDialogConfig();
    config.width = '500px';
    dialogRef = this.dialog.open(AcoCuitDialogComponent, config);
    dialogRef.componentInstance.title = 'Acopios';
    dialogRef.componentInstance.data = data;
  }

  removeFilter(chip: ChipFilterItem) {
    this.columnsDataSource.find(x => x.column === chip.Id).filter = null;
    this.historialChips = BuildUsuarioAgroChips(this.columnsDataSource);
    this.onChipsListChanged.emit();
    this.loadData();
  }

  showEditUsuarioDialog(row): void {
    this.router.navigate([PATH_EDITAR_USUARIO_AGRO, row.ID]);
  }

  showUserData(row): void {
    this.router.navigate([PATH_DETALLE_USUARIO_AGRO, row.ID]);
  }

  resetFilters(): void {
    this.columnsDataSource.forEach(x => {
      x.filter = null;
    })
    this.buildChips();
    this.loadData();
  }

  onGoToPage(next: boolean): void {
    if (this.cargando) {return;}
    if (next) {
      if (this.currentPage < this.resultsPageCount - 1) {
        // avanzar pagina
        this.currentPage++;
        this.loadData();
      }
    } else {
      if (this.currentPage > 0) {
        // retroceder pagina
        this.currentPage--;
        this.loadData();
      }
    }
  }

  changePageSize(e): void {
    this.currentPage = 0;
    this.loadData();
  }

  onViewEnter() {
    if (this.reloadList) {
      this.loadData();
      this.reloadList = false;
    }
  }

  getRolesNames(row: UsuarioAgro): string {
    return row.Roles && row.Roles.length ? row.Roles.map(x => x.Nombre).join(', ') : '';
  }

  getMaxWidthPaginador(): string {
    return (Number(this.agroTableWidth.replace('px', '')) - 20).toString() + 'px';
  }

  parseEstadoName(name: string): string {
    return this.estados.find(x => x.raw === name).estado
  }

  changeEstado(row: UsuarioAgro, e) {
    const previous = !e.checked;
    this.cuentasService.agroActivateDeactivate(row.ID, e.checked).subscribe(x => {
      this.snackBar.open(`Usuario ${e.checked ? 'activado' : 'desactivado'} correctamente.`, '', {
        duration: 2000,
      });
      row.Estado = e.checked ? 'ACTIVE' : 'INACTIVE';
    }, err => {
      setTimeout(x => e.source.checked = previous, 100);
      this.snackBar.open(`Ha ocurrido un error al cambiar el estado. Por favor, intente nuevamente.`, '', {
        duration: 2000,
      });
    })
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/usuario-agro-historial/usuario-agro-historial.component.ts